import React, { useState } from 'react';
import _unescape from 'lodash/unescape';
import Dialog from './Dialog';

export default function Snapshot(props) {

    const [imgLoaded, setImgLoaded] = useState(false);
    const [secImgLoaded, setSecImgLoaded] = useState(false);
    const [showMessage, setShowMessage] = useState(false);

    const unescapedUrl = encodeURIComponent(_unescape(props.item.productPageUrl));

   
    var firstPass = `/api/Snapshot?url=${unescapedUrl}`;
    var secondPass = `/api/Snapshot?url=${unescapedUrl}&firstPass=false`;


    const closeMessage = () => {
        setShowMessage(false);
    };

    const openStorePage = () => {
        setShowMessage(false);
      window.open(_unescape(props.item.productPageUrl), '_blank');
    };

  return (
      <div className="container">
          {!imgLoaded && <div className="snapshot">
              <i className="far fa-hourglass"></i>
              <div> Snapshot of product page loading...</div>
            
          </div>}
        
          {!secImgLoaded && <img className={`img-fluid image-${+ imgLoaded ? 'visible' : 'hidden'}`} src={firstPass} onClick={() => { setShowMessage(true) }} onLoad={() => setImgLoaded(true)} />}
         
          {imgLoaded && showMessage && <div className="message">
              <div className="d-flex justify-content-center p-2">
                 
                  <div className="text-center d-flex align-items-center ">
                      <i className="fa fa-exclamation-circle mr-2" aria-hidden="true"></i>
                      <span>This is a snapshot of the product page and not the {props.item.store} website, would you like to be taken to the website?</span>
                   </div>
                  
              </div>
              <div className="d-flex justify-content-center p-2">
                  <button className="btn btn-success btn-small mr-2" onClick={openStorePage}>Yes</button>
                  <button className="btn btn-primary btn-small" onClick={closeMessage}>No</button>
              </div>


          </div>}
      </div>
  );


    

}
